import { useMemo } from "react" // 추가
import Echart from "echarts-for-react"
import { langStore } from "@/stores/lang-store"
import { pdfBundle } from "./pdf-const"

const PdfChart = ({ xLabels = [], series = [] }) => {
  const { lang } = langStore()

  const option = useMemo(() => {
    if (!xLabels.length || !series.length) return null

    return {
      animation: false,
      legend: { show: false },
      grid: { left: "4%", right: "3%", bottom: 20, top: 20, containLabel: true },
      xAxis: {
        type: "category",
        data: xLabels,
        boundaryGap: false,
        axisLabel: { rotate: 0, interval: "auto", hideOverlap: false }
      },
      yAxis: { type: "value" },
      series: series.map((s) => ({
        name: pdfBundle.info[s.name][lang],
        type: "line",
        data: s.data,
        smooth: true,
        showSymbol: false,
        symbol: "circle",
        z: s.color === "#999" ? 20 : s.color === "#ED561B" ? 10 : 5,
        itemStyle: { color: "#fff", borderColor: s.color },
        lineStyle: { width: 1, color: s.color },
        areaStyle: s.color === "#ED561B" ? { color: s.color, opacity: 0.08 } : null
      }))
    }
  }, [xLabels, series, lang])

  if (!xLabels.length || !series.length) return null

  return <Echart style={{ width: "100%", height: "100%" }} option={option} notMerge={true} />
}

export default PdfChart
